module.exports = __webpack_public_path__ + "media/images/icons/model-icon-64bf76bde8caa46baef3c529c6fe9f8b.svg";